export default function Environment ()
{
  const winLocationDomain = (window.location.protocol + '//' + window.location.host).toLowerCase();

  this.getLocationDomain = () => winLocationDomain;
  this.version = window.bonaPage_BuildVer || 1;
  this.fullVersion = (window.bonaPage_ThemeId != null) ? (this.version + "." + window.bonaPage_ThemeVer) : window.version;
  this.adminResImgPath = window.WA.adminResImgPath || '/';


  const getTopWindowDo = (w) =>
  {
    try
    {
      if (w.parent && w.location.href !== w.parent.location.href)
      {
        if ((w.parent.location.protocol + '//' + w.parent.location.host).toLowerCase() === winLocationDomain)
        {
          return getwp(w.parent);
        }
        else
        {
          return w;
        }
      }
      else
      {
        return w;
      }
    }
    catch(err)
    {
      return w;
    }
  };


  const getTopWindow = () =>
  {
    try
    {
      if (top && top.document && (top.location.protocol + '//' + top.location.host).toLowerCase() === winLocationDomain)
      {
        return top;
      }
      else
      {
        return getTopWindowDo(window);
      }
    }
    catch(err)
    {
      return getTopWindowDo(window);
    }
  };


  this.topWindow = getTopWindow();
  this.isTopWindow = window === this.topWindow;

  this.internalPageType = this.topWindow.bonaPage_InternalPageType ||
  {
    isUndefinedPage : false,
    isWebPage : true,
    isAdminPage : false,
    isDialogPage : false,
    isSystemPage : false,
    isErrorPage : false,
    isError404Page : false
  };

  this.pageView = this.topWindow.bonaPage_PageView ||
  {
    isAnonymousView: true,
    isMemberView: false,
    isAdminView : false
  };

  this.statRes = window.bonaPage_StatRes || '/';

  this.getAdditionalDomainNames = () => (WA.AdminPanel && !WA.AdminPanel.isDisposed()) ? WA.AdminPanel.getPanelResources().AccountDomainNames : [this.topWindow.location.host];
  this.isCMSAdminMode = () => this.topWindow.contentarea && this.topWindow.contentarea.bonaPage_InternalPageType && (this.topWindow.contentarea.bonaPage_InternalPageType.isWebPage || this.topWindow.contentarea.bonaPage_InternalPageType.isSystemPage);
}